import style from "./style.module.scss";

export default function Paper({
  children,
  variant = "primary",
  padding,
  height,
  width,
  radius,
}: {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "tertiary" | "none";
  padding?: number | string;
  height?: number;
  width?: number | string;
  radius?: number;
}): JSX.Element {
  return (
    <div
      className={`${style.paper} ${style["paper--" + variant]}`}
      style={{
        padding,
        width,
        height: `${height}px`,
        borderRadius: `${radius}px`,
      }}
    >
      {children}
    </div>
  );
}
